<!-- <mat-nav-list>
  <div class="logo py-4">
    <img src="./assets/images/sf_logo.jpg" alt="Company Logo" />
  </div>
  <mat-divider></mat-divider>

  <a mat-list-item routerLinkActive="list-item-active" routerLink="/admin/dashboard">
    <mat-icon>dashboard</mat-icon> Dashboard
  </a>
  <a mat-list-item> <mat-icon>filter_vintage</mat-icon> Studio </a>
  <a mat-list-item> <mat-icon>redeem</mat-icon> Campaign </a>
  <a mat-list-item> <mat-icon>how_to_vote</mat-icon> Producs </a>
  <a mat-list-item> <mat-icon>store</mat-icon> Retail Stores </a>
  <a mat-list-item> <mat-icon>person</mat-icon> Userss </a>
</mat-nav-list> -->

<mat-nav-list *ngFor="let row of menuRights">
  <a mat-list-item routerLinkActive="list-item-active" [routerLink]="row.routerLink"
    *ngIf="!row.isParent && !row.exact" (click)="onClickMenu(row.name)">
    <mat-icon>{{row.icon}}</mat-icon> {{row.name}}
  </a>
  <a mat-list-item routerLinkActive="list-item-active" [routerLink]="row.routerLink" *ngIf="!row.isParent && row.exact"
    [routerLinkActiveOptions]="{exact: true}" (click)="onClickMenu()">
    <mat-icon>{{row.icon}}</mat-icon> {{row.name}}
  </a>
  <a mat-list-item routerLinkActive="list-item-active" *ngIf="row.isParent" (click)="onClickMenu(row.name);">
    <mat-icon>{{row.icon}}</mat-icon> {{row.name}}
    <mat-icon class="menu-button" [ngClass]="{'rotated' : row.showSubmenu}">expand_more</mat-icon>
  </a>
  <div class="submenu" [ngClass]="{'expanded' : row.showSubmenu}" *ngIf="row.isParent">
    <div *ngFor="let crow of row.childMenus">
      <a mat-list-item routerLinkActive="list-item-active" [routerLink]="crow.routerLink" *ngIf="!crow.exact" (click)="onClickMenu(row.name)">
        <mat-icon>{{crow.icon}}</mat-icon> {{crow.name}}
      </a>
      <a mat-list-item routerLinkActive="list-item-active" [routerLink]="crow.routerLink"
        [routerLinkActiveOptions]="{exact: true}" *ngIf="crow.exact" (click)="onClickMenu(row.name)">
        <mat-icon>{{crow.icon}}</mat-icon> {{crow.name}}
      </a>
    </div>
  </div>

</mat-nav-list>

<div class="qr-block text-center my-4">

  <img
    *ngIf="businessQRCode"
    [src]="businessQRCode"
    alt="Business QR"
    class="qr-img mb-3"
  />

  <div class="d-flex justify-content-center gap-3">
    <a *ngIf="businessQRCode"
       href="#!"
       mat-icon-button
       matTooltip="Copy URL"
       color="primary"
       [attr.aria-label]="'Copy business URL'"
       (click)="onClickCopyURL()">
      <i class="fa fa-copy" style="font-size: 22px;"></i>
    </a>
    <a *ngIf="businessQRCode"
       href="#!"
       mat-icon-button
       matTooltip="Download QR"
       color="primary"
       [attr.aria-label]="'Download QR image'"
       (click)="onClickDownloadQrCode()">
      <i class="fa fa-download" style="font-size: 22px;"></i>
    </a>

<div class="d-flex justify-content-center gap-3">
<button
  *ngIf="getTargetUrl()"
  mat-icon-button
  class="share-trigger"
  matTooltip="Share"
  (click)="openShareDialog(shareTpl)"
  aria-label="Open share dialog"
  type="button">
  <svg width="26" height="26" viewBox="0 0 44 44" aria-hidden="true">
    <defs>
      <linearGradient id="sfGrad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%"   stop-color="#59c3a6"/>
        <stop offset="50%"  stop-color="#4fa3ab"/>
        <stop offset="100%" stop-color="#263f8f"/>
      </linearGradient>
    </defs>
    <g fill="none" stroke="url(#sfGrad)" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
      <line x1="12" y1="22" x2="32" y2="11"/>
      <line x1="12" y1="22" x2="32" y2="33"/>
      <circle cx="12" cy="22" r="6"/>
      <circle cx="32" cy="11" r="6"/>
      <circle cx="32" cy="33" r="6"/>
    </g>
  </svg>
</button>

  <button
    *ngIf="businessQRCode"
    mat-icon-button
    class="share-trigger view"
    matTooltip="view site"
    aria-label="view site"
    type="button"
    (click)="onOpenProductList()">
    <mat-icon>open_in_new</mat-icon>
  </button>

</div>

<ng-template #shareTpl>
  <h2 mat-dialog-title>Share</h2>
  <mat-dialog-content>
    <div class="social-row">
<a class="social-btn fb" (click)="share('facebook')" target="_blank" rel="noopener" matTooltip="Facebook">
  <i class="fab fa-facebook-f"></i>
</a>
<a class="social-btn li" (click)="share('linkedin')" target="_blank" rel="noopener" matTooltip="LinkedIn">
  <i class="fab fa-linkedin-in"></i>
</a>
<a class="social-btn tw" (click)="share('twitter')" target="_blank" rel="noopener" matTooltip="X (Twitter)">
  <i class="fab fa-x-twitter"></i>
</a>
<a class="social-btn wa" (click)="share('whatsapp')" target="_blank" rel="noopener" matTooltip="WhatsApp">
  <i class="fab fa-whatsapp"></i>
</a>
<button class="social-btn ig" (click)="onShareInstagram()" matTooltip="Copy link, open Instagram">
  <i class="fab fa-instagram"></i>
</button>

    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
</ng-template>

  </div>
<label class="publish-deal-catalog" *ngIf="showPublishDealCatalog && businessQRCode">
  <input type="checkbox"
    [checked]="publishDealCatalog"
    [disabled]="publishingDealCatalog"
    (change)="onPublishDealCatalog($event)" />
  Publish to Alyro
</label>
<div>
  <img
    class="qr-logo mb-2 mt-2 mb-2"
    height="130"
    *ngFor="let preview of previewsLogo"
    [src]="preview"
    alt="Logo"
  />
</div>
<div class="logo text-center py-4 mt-2">
<!-- <button
  mat-flat-button
  class="upgrade-btn"
  (click)="openPricing($event)"
>
  <mat-icon>workspace_premium</mat-icon>
  Upgrade plan
</button> -->

</div>

</div>

<!-- <mat-nav-list *ngFor="let row of menuRights">
  <div class="profile-card">
    <div class="header">
      <h2>Soufiane FADIL</h2>
      <h4>example@email.com</h4>
    </div>
    <img src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Soufiane FADIL">
  </div>

  <mat-divider></mat-divider>

  <h2 matSubheader>Pages</h2>
  <a mat-list-item routerLinkActive="list-item-active" routerLink="/admin/dashboard" *ngIf="row.name == 'Dashboard'">
    <mat-icon>dashboard</mat-icon> Dashboard
  </a>
  <a mat-list-item routerLinkActive="list-item-active" routerLink="/admin/campaigns" *ngIf="row.name == 'Campaigns'">
    <mat-icon>redeem</mat-icon> Campaigns
  </a>
  <a mat-list-item *ngIf="row.name == 'Campaign Stats'">
    <mat-icon>table_chart</mat-icon> Campaign Stats
  </a>
  <a mat-list-item routerLinkActive="list-item-active" routerLink="/admin/retail-store"
    *ngIf="row.name == 'Retail Stores'">
    <mat-icon>store</mat-icon> Retail Stores
  </a>
  <a mat-list-item routerLinkActive="list-item-active" [routerLinkActiveOptions]="{exact: true}"
    routerLink="/admin/coupons" *ngIf="row.name == 'Reedem Coupons'">
    <mat-icon>receipt</mat-icon> Reedem Coupons
  </a>
  <a mat-list-item routerLinkActive="list-item-active" routerLink="/admin/coupons/validate-coupon"
    *ngIf="row.name == 'Validate & Reedem'">
    <mat-icon>task_alt</mat-icon> Validate & Reedem
  </a>
  <a mat-list-item routerLinkActive="list-item-active" routerLink="/admin/products" *ngIf="row.name == 'Products'">
    <mat-icon>how_to_vote</mat-icon> Product List
  </a>
  <a mat-list-item routerLinkActive="list-item-active" routerLink="/admin/users" *ngIf="row.name == 'Users'">
    <mat-icon>person</mat-icon> Users
  </a>
  <a mat-list-item routerLinkActive="list-item-active" routerLink="/admin/subscriptions"
    *ngIf="row.name == 'Subscriptions'">
    <mat-icon>credit_card</mat-icon> Subscriptions
  </a>
  <a mat-list-item routerLinkActive="list-item-active" routerLink="/admin/role-management"
    *ngIf="row.name == 'Role Management'">
    <mat-icon>playlist_add_check</mat-icon> Role Management
  </a>

  <a mat-list-item routerLinkActive="list-item-active" (click)="showSubmenu = !showSubmenu">
    <mat-icon>notifications_active</mat-icon> Notifications: <mat-icon class="menu-button"
      [ngClass]="{'rotated' : showSubmenu}">expand_more</mat-icon>
  </a>
  <div class="submenu" [ngClass]="{'expanded' : showSubmenu}  ">
    <a mat-list-item routerLinkActive="list-item-active" routerLink="/admin/notification/retailer">
      <mat-icon>contact_mail</mat-icon> Retailers
    </a>
    <a mat-list-item routerLinkActive="list-item-active">
      <mat-icon>business_center</mat-icon> Customers
    </a>
  </div>
</mat-nav-list> -->
 <app-giftcard></app-giftcard>
